import { Component,OnInit } from '@angular/core';
import { Service } from '../../../../class/service';
import { Cookies } from '../../../../class/cookies';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { QuickSearch } from '../../../../class/search';
import { View } from '../../view';
import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'app-formato-archivo01',
  templateUrl: './formato-archivo01.component.html',
  styleUrls: ['./formato-archivo01.component.css']
})
export class FormatoArchivo01Component extends View implements OnInit {
	//Modelo de datos
	private model: Object = { FK_CodigoPagaduri: '', FK_Tipo: '' };
	//Referencia del codigo
	private pk:Object = { PK_Id:0 }
	//Componentes a lo que se le realizaran validaciones personalizadas - ya que no son id autoincremental
	// ...
	//buquedarapida
	private qsFormatoarchivo:QuickSearch;
	private qsSetFormatoarchivo:Object;
	//lista a guardar
	private toSave:Array<Object> = [];
	
	constructor(public service: Service, public cookies: Cookies) {
		super(service,cookies,"formatoarchivo01-component");
		super.serviceNmae("formatoarchivo01");
	}
	
	ngOnInit() {
		super.filter({
			column:[
				{ name: 'campo', nickname: 'Campo' },
				{ name: 'cantidad', nickname: 'Cantidad' },
				{ name: 'caracter', nickname: 'Caracter' }
			]
		});
		//Validaciones personalizadas
		// ...
		//inician estructura de la busqueda rapida
		
		this.qsFormatoarchivo = {
			label: 'Formato archivo',
			search: {
				title:"Buscar Formato archivo",
				service: "formatoarchivo",
				column: [
					{ name:'PK_CodigoPagaduria', nickname: 'Codigo', visible: true },
					{ name:'PK_Tipo', nickname: 'Tipo', visible: true },
					{ name:'nombreArchivo', nickname: 'Nombre', visible: true },
				],
				toSearch:'',
			},
			
		}
	}

	private qsGetFormatoarchivo(data:Object):void{
		
		this.model["FK_CodigoPagaduria"] = data["data"]["PK_CodigoPagaduria"] || '';
		this.model["FK_Tipo"] = data["data"]["PK_Tipo"] || '';
	}

	//Un nuevo registro, iniciando datos
	private NEW(): void {
		this.resetComponent();
		this.list = false;
		this.action = 'Guardar';
	}
	private resetComponent():void {
		this.model = {};
		this.qsSetFormatoarchivo = { key:'', value:'' };
		this.toSave = [];
	}

	//Editar en base al codigo de referencia
	private EDIT(pk_: Object): void {
		this.pk = pk_;
		this.action = "Actualizar";
		this.list = false;
		this.getModelById();
	}

	//Para obtener y cargar el registro seleccionado
	private getModelById(): void {
		this.state = !this.state;
		this.service
			.GET('formatoarchivo01/' + this.pk["PK_Id"], '')
			.subscribe(res => {
				this.model = res["show"];
				this.qsSetFormatoarchivo = { 
					key: this.model["FK_CodigoPagaduria"], 
					value: this.model["FK_Tipo"] 
				};
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
        });
	}

	//Validar si guardar o modificar
	private actionCrud(): void {
		if (this.action.toUpperCase() == "GUARDAR") {
			this.save();
		} else {
			this.update();
		}
	}

	//Para eliminar el registro
	private DELETE(pk_: Object): void {
		this.state = !this.state;
		this.service.DELETE('formatoarchivo01/' + pk_["PK_Id"]).subscribe(res => {
			this.getList(this.pagination["current_page"], "");
			if (res["destroy"]) {
				this.openMd("El registro se elimino correctamente", "success");
			} else {
				this.openMd("El registro no se elimino", "danger");
			}
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
			this.openMd(err, "danger");
		});
	}

	//Guardar el registro
	private save(): void {
		this.state = !this.state;
		console.log({ data: JSON.stringify(this.model) });
		this.service.POST('formatoarchivo01', { data: JSON.stringify(this.toSave) }).subscribe(res => {
			this.state = !this.state;
			this.list = !this.list;
			if(res["create"]){
				this.openMd('Registro guardado corectamente','success');
				this.pk["PK_Id"] = res["PK_Id"];
			}
			this.getList(1, "");
		}, err => {
            this.openMd(err,'danger');
			this.state = !this.state;
		});
	}

	//Modificar el registro
	private update(): void {
		this.state = !this.state;
		this.service
        .PUT('formatoarchivo01/' + this.pk["PK_Id"], { data: JSON.stringify(this.model) })
        .subscribe(res => {			
			if (res["update"]) {
				this.state = !this.state;
				this.getList(1,"");
				this.openMd("El registro se ha modificado correctamente", "success");
				this.list = !this.list;
			} else {
				this.openMd("El registro no se ha podido modificar", "danger");
			}
		}, err => {
			console.log(err);
		});
	}
	
	private add():void{
		var a = this.model["FK_CodigoPagaduria"];
		var b = this.model["FK_Tipo"];
		this.toSave.push(this.model);
		this.model = {};
		this.model["FK_CodigoPagaduria"] = a;
		this.model["FK_Tipo"] = b;
	}

	private discard(data:Object):void{
		this.toSave.splice(this.toSave.indexOf(data),1);
	}

}



// WEBPACK FOOTER //
// ./src/app/component/module/archivo/formato-archivo01/formato-archivo01.component.ts